export function Currency({children = 0}: any) {
  return (
    <span>${children.toFixed(2)}</span>
  );
}
